import { Vue } from "vue-class-component";

export default class VueBase extends Vue {
    isBusy: boolean = false;
}